import appConstants from '../constants/appConstants';
import { authPost } from '../utils/fecth-wrappers';

const API_BASE_URL = appConstants.API.icApiDealers;

/**
 * Serviço para validação de telefone via OTP
 */
export class PhoneVerificationService {
  /**
   * Valida o código OTP enviado pelo usuário
   * @param {string} userId - ID do usuário no MongoDB
   * @param {string} code - Código OTP de 6 dígitos
   * @returns {Promise<Object>} Resposta da API
   */
  static async verifyCode(userId, code) {
    try {
      const response = await authPost(`${API_BASE_URL}/profile/validate-phone`, {
        userId,
        code,
        isRetryCode: false,
      });

      return response;
    } catch (error) {
      console.error('Erro na verificação do código:', error);

      // A resposta de erro pode estar em error.response.data ou diretamente em error
      const errorData = error.response?.data || error;
      const errorCode = errorData.code || error.code;
      const errorMessage = errorData.message || error.message;

      // Tratamento específico para erro 1009 - Limite de tentativas excedido
      if (errorCode === 1009) {
        throw new Error(errorMessage);
      }

      // Tratamento específico para erro 1008 - OTP expirado
      if (errorCode === 1008) {
        throw new Error(errorMessage);
      }

      // Tratamento específico para erro 1007 - OTP inválido
      if (errorCode === 1007) {
        throw new Error(errorMessage);
      }

      throw new Error(errorMessage || 'Código inválido');
    }
  }

  /**
   * Reenvia código OTP para validação de telefone
   * @param {string} userId - ID do usuário no MongoDB
   * @returns {Promise<Object>} Resposta da API
   */
  static async resendCode(userId, channel = 'whatsapp') {
    try {
      const response = await authPost(`${API_BASE_URL}/profile/validate-phone`, {
        userId,
        isRetryCode: true,
        channel,
      });

      return response;
    } catch (error) {
      console.error('Erro ao reenviar código:', error);

      // A resposta de erro pode estar em error.response.data ou diretamente em error
      const errorData = error.response?.data || error;
      const errorCode = errorData.code || error.code;
      const errorMessage = errorData.message || error.message;

      // Tratamento específico para erro 1009 - Limite de tentativas excedido
      if (errorCode === 1009) {
        throw new Error(errorMessage);
      }

      // Tratamento específico para erro 1008 - OTP expirado
      if (errorCode === 1008) {
        throw new Error(errorMessage);
      }

      throw new Error(errorMessage || 'Erro ao reenviar código');
    }
  }
}
